import React from 'react';
import { CtaButton } from './CtaButton';
import { QuoteMockup } from './QuoteMockup';
import { Reveal } from './Reveal';
import { site } from '../data/landing';
const trustBadges = [{
  icon: '⭐⭐⭐⭐⭐',
  label: 'Técnicos activos'
}, {
  icon: '🔒',
  label: 'Pago seguro'
}, {
  icon: '📲',
  label: 'Funciona en Android e iPhone'
}];
const paymentMethods = [{
  emoji: '📱',
  label: 'Pago Móvil',
  sub: 'Tasa BCV oficial'
}, {
  emoji: '💳',
  label: 'Tarjeta',
  sub: 'Visa / Mastercard'
}, {
  emoji: '₿',
  label: 'Binance Pay',
  sub: 'USDT / BTC'
}];
export function HeroSection() {
  return <section id="top" className="bg-ink pb-16 pt-24 text-white sm:pb-24 sm:pt-32" data-id="element-115" data-mp="2mufi418j3dbv">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-[1.05fr_1fr] lg:gap-14" data-id="element-116" data-mp="2rt0grw84toy7">
        <Reveal data-id="element-117" data-mp="3fi1k5523y9wm">
          <h1 className="text-[32px] font-black leading-[1.1] tracking-tight sm:text-5xl lg:text-[54px]" data-id="element-118" data-mp="3fhjr0haqsbsx">
            Genera cotizaciones profesionales <span className="text-success-light" data-id="element-119" data-mp="3kbe95gap8ipw">en 2 minutos</span> — directo desde tu celular
          </h1>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-slate-300 sm:text-xl" data-id="element-120" data-mp="2fd5tzgfw4xcz">
            El técnico que cotiza con PDF <strong className="font-bold text-white" data-id="element-121" data-mp="2p51yb98kljpn">gana el trabajo</strong>. El que cotiza de palabra, lo pierde.
          </p>
          <div className="mt-8" data-id="element-122" data-mp="2kdk2t0pbgbc2">
            <CtaButton data-id="element-123" data-mp="2kcih82aoc6g3">Quiero mi Cotizador PRO — {site.price}</CtaButton>
            <p className="mt-3 text-sm text-slate-300" data-id="element-124" data-mp="2z26hr1b1712r">✅ Acceso inmediato · ✅ Sin mensualidades · ✅ Funciona en tu celular</p>
          </div>

          {/* Métodos de pago */}
          <div className="mt-6 rounded-xl border border-white/10 bg-white/5 px-4 py-3" data-id="element-125" data-mp="384fuzyxop8ju">
            <p className="mb-2.5 text-xs font-semibold uppercase tracking-widest text-slate-400" data-id="element-126" data-mp="334l43vdwsiys">Formas de pago</p>
            <div className="flex flex-wrap gap-2" data-id="element-127" data-mp="1dr7txpj480pr">
              {paymentMethods.map(m => <div key={m.label} className={`flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium ${m.label === 'Pago Móvil' ? 'bg-success/20 text-success-light ring-1 ring-success/40' : 'bg-white/5 text-slate-200'}`} data-id="element-128" data-mp="18rv54z8oojkj">
                  <span aria-hidden="true" data-id="element-129" data-mp="3msug4dlk75x4">{m.emoji}</span>
                  <span data-id="element-130" data-mp="3mufb24bscqvi">
                    {m.label}
                    <span className="ml-1 text-xs font-normal opacity-70" data-id="element-131" data-mp="3rsp86kh2m1jr">{m.sub}</span>
                  </span>
                </div>)}
            </div>
          </div>

          <ul className="mt-6 flex flex-wrap gap-2 sm:gap-3" data-id="element-132" data-mp="5cupmmuqncln">
            {trustBadges.map(badge => <li key={badge.label} className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs font-medium text-slate-200 sm:text-sm" data-id="element-133" data-mp="abfnwgqfjm7g">
                <span aria-hidden="true" data-id="element-134" data-mp="jd5gvqzymt7c">{badge.icon}</span>
                {badge.label}
              </li>)}
          </ul>
        </Reveal>
        <Reveal delay={0.08} data-id="element-135" data-mp="1yvbjjtkjroit">
          <QuoteMockup data-id="element-136" data-mp="1yv1zsnq3idlk" />
        </Reveal>
      </div>
    </section>;
}